import { useTranslation } from "react-i18next";
import type { FC } from "react";
import type { NoteStatus } from "@/services/api/entities/note/types";
import { noteDateFormat } from "../helpers";
import styles from "../styles.module.scss";

interface Props {
  date: string;
  dueDate: string;
  isShowFooter?: boolean;
  status: NoteStatus;
}

export const Footer: FC<Props> = ({ date, dueDate, status }) => {
  const { t } = useTranslation();

  const formattedDate = date ? noteDateFormat(date) : null;
  const formattedDueDate = dueDate ? noteDateFormat(dueDate) : null;
  return (
    <div className={styles.footer}>
      {formattedDate && (
        <div className={styles.date}>
          {t("common.created").toLowerCase()} {formattedDate}
        </div>
      )}
      <div className={styles.date}>
        {status?.length && status !== "DONE" && dueDate !== "" && formattedDueDate && (
          <>
            {" "}
            {t("notesPage.due").toLowerCase()} {formattedDueDate}
          </>
        )}
      </div>
    </div>
  );
};
